<template>
  <div class="echart" ref="echart"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'jh-echart',

  props: {
    options: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      chart: null
    }
  },

  watch: {
    options (newOptions) {
      this.chart.setOption(newOptions,true)
    }
  },

  mounted () {
    this.chart = echarts.init(this.$refs.echart)
    this.chart.setOption(this.options,true)
    this.chart.on('click', params => {
      this.$emit('click', params)
    })
    window.addEventListener('resize', this.resize)
  },

  methods: {
    resize () {
      this.chart.resize()
    }
  },

  beforeDestroyed () {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style lang="scss" scoped>
.echart {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
